import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import Constants from '../../submodules/logictry_config/constants';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Wrapper = styled.div`
  aspect-ratio: 1;
  width: auto;
  width: 45px;
  height: 45px;
  border-radius: 0.5rem;
  overflow: hidden;

  input[type='color'] {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 100%;
  }

  input[type='color']::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  input[type='color']::-webkit-color-swatch {
    border: none;
    border-radius: inherit;
  }

  input[type='color']::-moz-color-swatch {
    border: none;
    border-radius: inherit;
  }
`;

export default class ColorPicker extends LogictryComponent {
  static propTypes = {
    color: PropTypes.string,
    onChange: PropTypes.func,
  }
  changed = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {
    const { color } = this.props;
    return (
      <Wrapper>
        <input onChange={this.changed} onInput={this.changed} type="color" value={color || Constants.PrimaryColor}></input>
      </Wrapper>
    );
  }
}
